import React from 'react';

import type { EventLocation } from '@vlabs/api/artemy/model';
import {
  GeoLocation, GeoLocationMarker,
} from '@vlabs/uikit';
import { useDynamicCoordinates } from '@vlabs/uikit/components/geo-location/useDynamicCoordinates';
import { useTranslation } from 'react-i18next';

import st from './BaseMap.module.sass';
import type { MapMarker } from './types';

interface BaseMapPoint3Props {
  location?: EventLocation | null;
  markers?: MapMarker[];
}

export function BaseMapPoint3({
  location = null,
  markers = [],
}: BaseMapPoint3Props): React.JSX.Element {
  const { t } = useTranslation();

  const latitude = location?.geo_position?.latitude;
  const longitude = location?.geo_position?.longitude;
  const hasCoordinates = latitude != null && longitude != null;
  const position = useDynamicCoordinates({
    latitude: latitude ?? 0,
    longitude: longitude ?? 0,
  });

  if (!hasCoordinates) {
    return (
      <div
        className={st.NoData}
        data-testid="workspace.mapStream.emptyContent"
      >
        {t('lunapoint:панель оператора.no data')}
      </div>
    );
  }

  return (
    <div className={st.Root}>
      <div
        className={st.Content}
        data-testid="workspace.mapStream.content"
      >
        <GeoLocation
          center={position}
          toggleFullScreenMode={false}
        >
          {markers.map((marker) => (
            <GeoLocationMarker
              anchor={marker.position}
              className={st.Marker}
              key={marker.id}
            />
          ))}
        </GeoLocation>
      </div>
    </div>
  );
}
